import requests from "./request";

// AI开始
// 登录
export function login(data) {
  return requests({
    url: '/api/subsystem/bigs/orgLogin',
    method: 'post',
    data
  })
}
// 验证码
export function getCodeInfo(now) {
  return requests({
    url: '/api/subsystem/bigs/randomImage?key='+now,
    method: 'get',
  })
}
// token校验
export function authCheck() {
  return requests({
    url: '/api/subsystem/authbs/authCheck',
    method: 'get',
    headers: {
      // 'X-Access-Token':localStorage.getItem("token")
    },
  })
}
// 匿名AI对话
export function chat(data) {
  return requests({
    url: '/api/aiChat/anonymous/chat',
    method: 'post',
    data
  })
}
// AI获取常见问题
export function question() {
  return requests({
    url: '/api/aiChat/anonymous/question',
    method: 'get',
    headers: {
      // 'X-Access-Token':localStorage.getItem("token")
    },
  })
}
// AI点赞1-点踩-1
export function like(data) {
  return requests({
    url: '/api/aiChat/anonymous/like',
    method: 'post',
    data
  })
}

// 上传图片
export function uploadimg(data) {
  return requests({
    url: '/sys/common/upload',
    method: 'post',
    data:data,
    headers: {
      'Content-Type':'multipart/form-data',
      // 'X-Access-Token':localStorage.getItem("token")
    },
  })
}

// 文字转语音
export function ttsById(data) {
  return requests({
    url: '/api/aiChat/anonymous/ttsById',
    method: 'post',
    data
  })
}

// 图片生成
export function imgchat(data) {
  return requests({
    url: '/api/aiChat/chat',
    method: 'post',
    data:data,
    headers: {
      // 'X-Access-Token':localStorage.getItem("token")
    },
  })
}

// 语音转文字
export function nioAsrService(data) {
  return requests({
    url: '/api/asrService/nioAsrService',
    method: 'post',
    data:data,
    headers: {
      'Content-Type':'multipart/form-data',
      // 'X-Access-Token':localStorage.getItem("token")
    },
  })
}

// AI结束


   // 智能设备_监测数据_重点监控
   export function gardenBelow(farmId,greenHouseId,auths) {
    return requests({
      url: '/api/subsystem/bigs/bsSurvDevice?farmId='+farmId+'&greenHouseId='+greenHouseId+'&auths='+auths,
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }
  // 智能设备_虫情监测
  export function bugSurvList(farmId,auths,pageNo,pageSize) {
    return requests({
      url: '/api/subsystem/bigs/bsBugSurv?farmId='+farmId+'&auths='+auths+'&pageNo='+pageNo+'&pageSize='+pageSize,
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }
  // 智能设备_一周温度湿度
  export function weekTemp(auths) {
    return requests({
      url: '/api/subsystem/bigs/bsWeekTemp?auths='+auths,
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }
   // 信息预警列表
   export function alertMessageList(auths) {
    return requests({
      url: '/api/subsystem/bigs/alertMessageList?auths='+auths,
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }

  // 产业发展_农事记录
  export function cyfznsjl(auths) {
    return requests({
      url: '/api/subsystem/bigs/cyfznsjl?auths='+auths,
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }

  //  产业发展_经营主体列表
  export function jyztList(auths) {
    return requests({
      url: '/api/subsystem/bigs/jyztList?auths='+auths,
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }




  //  产经营主体_生态预警天气现用
  export function orgEnvAlertPage(auths,pageNo,pageSize,areaId) {
    return requests({
      url: '/api/subsystem/bigs/orgEnvAlertPage?auths='+auths+'&pageNo='+pageNo+'&pageSize='+pageSize+'&areaId='+areaId,
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }





    //  产经营主体_生态预警天气
    export function entMessagePage(auths,companyId) {
      return requests({
        url: '/api/subsystem/bigs/entMessagePage?auths='+auths+'&companyId='+companyId,
        method: 'get',
        headers: {
          // 'X-Access-Token':window.sessionStorage.getItem("token")
        },
      })
    }
    //  预警列表现用
    export function entAlertPage(auths,pageNo,pageSize,companyId) {
      return requests({
        url: '/api/subsystem/bigs/entAlertPage?auths='+auths+'&pageNo='+pageNo+'&pageSize='+pageSize+'&companyId='+companyId,
        method: 'get',
        headers: {
          // 'X-Access-Token':window.sessionStorage.getItem("token")
        },
      })
    }
    //  预警列表
    export function alertList(auths,companyId) {
      return requests({
        url: '/api/subsystem/bigs/alertList?auths='+auths+'&companyId='+companyId,
        method: 'get',
        headers: {
          // 'X-Access-Token':window.sessionStorage.getItem("token")
        },
      })
    }
     //  非控制设备列表
     export function entNonControlDevice(auths,companyId) {
      return requests({
        url: '/api/subsystem/bigs/entNonControlDevice?auths='+auths+'&companyId='+companyId,
        method: 'get',
        headers: {
          // 'X-Access-Token':window.sessionStorage.getItem("token")
        },
      })
    }
   


    // 一张图接口开始
//  基地概况接口
export function entDetail(farmId) {
  return requests({
    url: '/api/unibs/entDetail?farmId='+farmId,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}
//  种植作物接口
export function plantCrops(farmId) {
  return requests({
    url: '/api/unibs/plantCrops?farmId='+farmId,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}

// 农事记录
export function MissionPage(farmId,pageNo,pageSize) {
  return requests({
    url: '/api/unibs/MissionPage?farmId='+farmId+'&pageNo='+pageNo+'&pageSize='+pageSize,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}
// 生态预警
export function envAlertPage(farmId,pageNo,pageSize) {
  return requests({
    url: '/api/unibs/envAlertPage?farmId='+farmId+'&pageNo='+pageNo+'&pageSize='+pageSize,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}
//  所有的非控制设备
export function nonControlDevice(farmId) {
  return requests({
    url: '/api/unibs/nonControlDevice?farmId='+farmId,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}
// 地块列表
export function landList(farmId,landName) {
  return requests({
    url: '/api/unibs/landList?farmId='+farmId+'&landName='+landName,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}
//  地块详情
export function landDetail(landId) {
  return requests({
    url: '/api/unibs/landDetail?landId='+landId,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}
//  环境监测_苗情监测
export function deviceStatus(farmId) {
  return requests({
    url: '/api/unibs/deviceStatus?farmId='+farmId,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}
//  查询单个设备监测数据
export function getDeviceTransData(deployId,pageNo,pageSize,startTime,endTime) {
  return requests({
    url: '/api/unibs/getDeviceTransData?deployId='+deployId+'&pageNo='+pageNo+'&pageSize='+pageSize+'&startTime='+startTime+'&endTime='+endTime,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}
 // 公共-根据设备编号获取历史数据曲线
 export function deviceSummary(obj) {
  return requests({
    url: '/api/unibs/deviceSummary',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
    method: 'post',
    data:obj
  })
}

 // http协议控制柜控制项
 export function httpCabItemList(deployId) {
  return requests({
    url: '/api/unibs/httpCabItemList?deployId='+deployId,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}

 // 公共-设备控制指令下发
 export function cmdDevice(obj) {
  return requests({
    url: '/api/unibs/cmdDevice',
    method: 'post',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
    data:obj
  })
}
 //  摄像头列表
 export function camSurvPage(farmId,pageNo,pageSize,deviceType) {
  return requests({
    url: '/api/unibs/devicePage?farmId='+farmId+'&pageNo='+pageNo+'&pageSize='+pageSize+'&deviceType='+deviceType,
    method: 'get',
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}


//  摄像头控制开始
export function cameraStart(obj) {
  return requests({
    url: '/api/subsystem/bigs/cameraStart',
    method: 'post',
    data:obj,
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}
//  摄像头控制结束
export function cameraStop(val) {
  return requests({
    url: '/api/subsystem/bigs/cameraStop',
    method: 'post',
    data:val,
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}

//  摄像头调用记录api
export function deviceInvoke(data) {
  return requests({
    url: '/api/farm/DeviceControl/deviceInvoke',
    method: 'post',
    data:data,
    headers: {
      'X-Access-Token':localStorage.getItem('token')
    },
  })
}

    // 一张图接口结束